var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "admin-content-area",
      attrs: { id: "page-content-wrapper" }
    },
    [_vm._m(0), _vm._v(" "), _c("app-backend-footer")],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "container-fluid xyz" }, [
      _c("div", { staticClass: "page-header-top-container" }, [
        _c("div", { staticClass: "page-name" }, [_vm._v("Color Chart")])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "admin-page-content" }, [
        _c("div", { staticClass: "color-chart-main col-12 float-l" }, [
          _c("div", { staticClass: "row" }, [
            _c(
              "p",
              {
                staticClass:
                  "heading-text-20 line-height-24 color-098de1 font-text-regular-san"
              },
              [_vm._v(" Primary Colors ")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "color-platte-main width-full" }, [
              _c(
                "div",
                {
                  staticClass:
                    "colo-platte-inner colpie-17 bg-color-098de1 border-radius-5 mr-50 float-l"
                },
                [
                  _c(
                    "p",
                    {
                      staticClass:
                        "center heading-text-20 line-height-24 color-ffffff pt-100 pb-100 pl-50 pr-50"
                    },
                    [_vm._v("#098de1")]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "colo-platte-inner colpie-17 bg-color-154174 border-radius-5 mr-50 float-l"
                },
                [
                  _c(
                    "p",
                    {
                      staticClass:
                        "center heading-text-20 line-height-24 color-ffffff pt-100 pb-100 pl-50 pr-50"
                    },
                    [_vm._v("#154174")]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "colo-platte-inner colpie-17 bg-color-c3202b border-radius-5 mr-50 float-l"
                },
                [
                  _c(
                    "p",
                    {
                      staticClass:
                        "center heading-text-20 line-height-24 color-ffffff pt-100 pb-100 pl-50 pr-50"
                    },
                    [_vm._v("#c3202b")]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "colo-platte-inner colpie-17 bg-color-607d8b border-radius-5 mr-50 float-l"
                },
                [
                  _c(
                    "p",
                    {
                      staticClass:
                        "center heading-text-20 line-height-24 color-ffffff pt-100 pb-100 pl-50 pr-50"
                    },
                    [_vm._v("#607d8b")]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "colo-platte-inner colpie-17  bg-color-999999 border-radius-5 float-l"
                },
                [
                  _c(
                    "p",
                    {
                      staticClass:
                        "center heading-text-20 line-height-24 color-ffffff pt-100 pb-100 pl-50 pr-50"
                    },
                    [_vm._v("#999999")]
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c(
              "p",
              {
                staticClass:
                  "heading-text-20 line-height-24 font-text-regular-san color-9c1a22 mt-70"
              },
              [_vm._v(" Secondary Colors ")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "color-platte-main width-full" }, [
              _c(
                "div",
                {
                  staticClass:
                    "colo-platte-inner colpie-17 bg-color-97cbed border-radius-5 mr-50 float-l"
                },
                [
                  _c(
                    "p",
                    {
                      staticClass:
                        "center heading-text-20 line-height-24 color-ffffff pt-12 pb-12 pl-50 pr-50 mb-0"
                    },
                    [_vm._v("#97cbed")]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "colo-platte-inner colpie-17 bg-color-9badc1 border-radius-5 mr-50 float-l"
                },
                [
                  _c(
                    "p",
                    {
                      staticClass:
                        "center heading-text-20 line-height-24 color-ffffff pt-12 pb-12 pl-50 pr-50 mb-0"
                    },
                    [_vm._v("#9badc1")]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "colo-platte-inner colpie-17 bg-color-e1a0a4 border-radius-5 mr-50 float-l"
                },
                [
                  _c(
                    "p",
                    {
                      staticClass:
                        "center heading-text-20 line-height-24 color-ffffff pt-12 pb-12 pl-50 pr-50 mb-0"
                    },
                    [_vm._v("#e1a0a4")]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "colo-platte-inner colpie-17 bg-color-b9c5cb border-radius-5 mr-50 float-l"
                },
                [
                  _c(
                    "p",
                    {
                      staticClass:
                        "center heading-text-20 line-height-24 color-ffffff pt-12 pb-12 pl-50 pr-50 mb-0"
                    },
                    [_vm._v("#b9c5cb")]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "colo-platte-inner colpie-17 bg-color-dddddd border-radius-5 float-l"
                },
                [
                  _c(
                    "p",
                    {
                      staticClass:
                        "center heading-text-20 line-height-24 color-ffffff pt-12 pb-12 pl-50 pr-50 mb-0"
                    },
                    [_vm._v("#dddddd")]
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "color-platte-main width-full mt-8" }, [
              _c(
                "div",
                {
                  staticClass:
                    "colo-platte-inner colpie-17 bg-color-67b7e9 border-radius-5 mr-50 float-l"
                },
                [
                  _c(
                    "p",
                    {
                      staticClass:
                        "center heading-text-20 line-height-24 color-ffffff pt-12 pb-12 pl-50 pr-50 mb-0"
                    },
                    [_vm._v("#67b7e9")]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "colo-platte-inner colpie-17 bg-color-6f89a8 border-radius-5 mr-50 float-l"
                },
                [
                  _c(
                    "p",
                    {
                      staticClass:
                        "center heading-text-20 line-height-24 color-ffffff pt-12 pb-12 pl-50 pr-50 mb-0"
                    },
                    [_vm._v("#6f89a8")]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "colo-platte-inner colpie-17 bg-color-d7757c border-radius-5 mr-50 float-l"
                },
                [
                  _c(
                    "p",
                    {
                      staticClass:
                        "center heading-text-20 line-height-24 color-ffffff pt-12 pb-12 pl-50 pr-50 mb-0"
                    },
                    [_vm._v("#d7757c")]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "colo-platte-inner colpie-17 bg-color-9cadb5 border-radius-5 mr-50 float-l"
                },
                [
                  _c(
                    "p",
                    {
                      staticClass:
                        "center heading-text-20 line-height-24 color-ffffff pt-12 pb-12 pl-50 pr-50 mb-0"
                    },
                    [_vm._v("#9cadb5")]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "colo-platte-inner colpie-17 bg-color-bebebe border-radius-5 float-l"
                },
                [
                  _c(
                    "p",
                    {
                      staticClass:
                        "center heading-text-20 line-height-24 color-ffffff pt-12 pb-12 pl-50 pr-50 mb-0"
                    },
                    [_vm._v("#bebebe")]
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "color-platte-main width-full mt-8" }, [
              _c(
                "div",
                {
                  staticClass:
                    "colo-platte-inner colpie-17 bg-color-0771b4 border-radius-5 mr-50 float-l"
                },
                [
                  _c(
                    "p",
                    {
                      staticClass:
                        "center heading-text-20 line-height-24 color-ffffff pt-12 pb-12 pl-50 pr-50 mb-0"
                    },
                    [_vm._v("#0771b4")]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "colo-platte-inner colpie-17 bg-color-42658e border-radius-5 mr-50 float-l"
                },
                [
                  _c(
                    "p",
                    {
                      staticClass:
                        "center heading-text-20 line-height-24 color-ffffff pt-12 pb-12 pl-50 pr-50 mb-0"
                    },
                    [_vm._v("#42658e")]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "colo-platte-inner colpie-17 bg-color-9c1a22 border-radius-5 mr-50 float-l"
                },
                [
                  _c(
                    "p",
                    {
                      staticClass:
                        "center heading-text-20 line-height-24 color-ffffff pt-12 pb-12 pl-50 pr-50 mb-0"
                    },
                    [_vm._v("#9c1a22")]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "colo-platte-inner colpie-17 bg-color-4d646f border-radius-5 mr-50 float-l"
                },
                [
                  _c(
                    "p",
                    {
                      staticClass:
                        "center heading-text-20 line-height-24 color-ffffff pt-12 pb-12 pl-50 pr-50 mb-0"
                    },
                    [_vm._v("#4d646f")]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "colo-platte-inner colpie-17 bg-color-7a7a7a border-radius-5 float-l"
                },
                [
                  _c(
                    "p",
                    {
                      staticClass:
                        "center heading-text-20 line-height-24 color-ffffff pt-12 pb-12 pl-50 pr-50 mb-0"
                    },
                    [_vm._v("#7a7a7a")]
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "color-platte-main width-full mt-8" }, [
              _c(
                "div",
                {
                  staticClass:
                    "colo-platte-inner colpie-17 bg-color-055587 border-radius-5 mr-50 float-l"
                },
                [
                  _c(
                    "p",
                    {
                      staticClass:
                        "center heading-text-20 line-height-24 color-ffffff pt-12 pb-12 pl-50 pr-50 mb-0"
                    },
                    [_vm._v("#055587")]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "colo-platte-inner colpie-17 bg-color-0d2746 border-radius-5 mr-50 float-l"
                },
                [
                  _c(
                    "p",
                    {
                      staticClass:
                        "center heading-text-20 line-height-24 color-ffffff pt-12 pb-12 pl-50 pr-50 mb-0"
                    },
                    [_vm._v("#0d2746")]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "colo-platte-inner colpie-17 bg-color-75131a border-radius-5 mr-50 float-l"
                },
                [
                  _c(
                    "p",
                    {
                      staticClass:
                        "center heading-text-20 line-height-24 color-ffffff pt-12 pb-12 pl-50 pr-50 mb-0"
                    },
                    [_vm._v("#75131a")]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "colo-platte-inner colpie-17 bg-color-3a4b53 border-radius-5 mr-50 float-l"
                },
                [
                  _c(
                    "p",
                    {
                      staticClass:
                        "center heading-text-20 line-height-24 color-ffffff pt-12 pb-12 pl-50 pr-50 mb-0"
                    },
                    [_vm._v("#3a4b53")]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "colo-platte-inner colpie-17 bg-color-444444 border-radius-5 float-l"
                },
                [
                  _c(
                    "p",
                    {
                      staticClass:
                        "center heading-text-20 line-height-24 color-ffffff pt-12 pb-12 pl-50 pr-50 mb-0"
                    },
                    [_vm._v("#444444")]
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c(
              "p",
              {
                staticClass:
                  "heading-text-20 line-height-24 font-text-regular-san color-71aa3f mt-70"
              },
              [_vm._v(" Other Colors ")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "color-platte-main width-full mt-8" }, [
              _c(
                "div",
                {
                  staticClass:
                    "colo-platte-inner colpie-17 bg-color-def1cc border-radius-5 mr-50 float-l"
                },
                [
                  _c(
                    "p",
                    {
                      staticClass:
                        "center heading-text-20 line-height-24 color-ffffff pt-12 pb-12 pl-50 pr-50 mb-0"
                    },
                    [_vm._v("#def1cc")]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "colo-platte-inner colpie-17 bg-color-fceed6 border-radius-5 mr-50 float-l"
                },
                [
                  _c(
                    "p",
                    {
                      staticClass:
                        "center heading-text-20 line-height-24 color-ffffff pt-12 pb-12 pl-50 pr-50 mb-0"
                    },
                    [_vm._v("#fceed6")]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "colo-platte-inner colpie-17 bg-color-d2f3f8 border-radius-5 float-l"
                },
                [
                  _c(
                    "p",
                    {
                      staticClass:
                        "center heading-text-20 line-height-24 color-ffffff pt-12 pb-12 pl-50 pr-50 mb-0"
                    },
                    [_vm._v("#d2f3f8")]
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "color-platte-main width-full mt-8" }, [
              _c(
                "div",
                {
                  staticClass:
                    "colo-platte-inner colpie-17 bg-color-a6c888 border-radius-5 mr-50 float-l"
                },
                [
                  _c(
                    "p",
                    {
                      staticClass:
                        "center heading-text-20 line-height-24 color-ffffff pt-12 pb-12 pl-50 pr-50 mb-0"
                    },
                    [_vm._v("#a6c888")]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "colo-platte-inner colpie-17 bg-color-fbd28b border-radius-5 mr-50 float-l"
                },
                [
                  _c(
                    "p",
                    {
                      staticClass:
                        "center heading-text-20 line-height-24 color-ffffff pt-12 pb-12 pl-50 pr-50 mb-0"
                    },
                    [_vm._v("#fbd28b")]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "colo-platte-inner colpie-17 bg-color-a9dfe5 border-radius-5 float-l"
                },
                [
                  _c(
                    "p",
                    {
                      staticClass:
                        "center heading-text-20 line-height-24 color-ffffff pt-12 pb-12 pl-50 pr-50 mb-0"
                    },
                    [_vm._v("#a9dfe5")]
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "color-platte-main width-full mt-8" }, [
              _c(
                "div",
                {
                  staticClass:
                    "colo-platte-inner colpie-17 bg-color-71aa3f border-radius-5 mr-50 float-l"
                },
                [
                  _c(
                    "p",
                    {
                      staticClass:
                        "center heading-text-20 line-height-24 color-ffffff pt-12 pb-12 pl-50 pr-50 mb-0"
                    },
                    [_vm._v("#71aa3f")]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "colo-platte-inner colpie-17 bg-color-ffbb44 border-radius-5 mr-50 float-l"
                },
                [
                  _c(
                    "p",
                    {
                      staticClass:
                        "center heading-text-20 line-height-24 color-ffffff pt-12 pb-12 pl-50 pr-50 mb-0"
                    },
                    [_vm._v("#ffbb44")]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "colo-platte-inner colpie-17 bg-color-32a3b0 border-radius-5 float-l"
                },
                [
                  _c(
                    "p",
                    {
                      staticClass:
                        "center heading-text-20 line-height-24 color-ffffff pt-12 pb-12 pl-50 pr-50 mb-0"
                    },
                    [_vm._v("#32a3b0")]
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "color-platte-main width-full mt-8" }, [
              _c(
                "div",
                {
                  staticClass:
                    "colo-platte-inner colpie-17 bg-color-446626 border-radius-5 mr-50 float-l"
                },
                [
                  _c(
                    "p",
                    {
                      staticClass:
                        "center heading-text-20 line-height-24 color-ffffff pt-12 pb-12 pl-50 pr-50 mb-0"
                    },
                    [_vm._v("#446626")]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "colo-platte-inner colpie-17 bg-color-cc9636 border-radius-5 mr-50 float-l"
                },
                [
                  _c(
                    "p",
                    {
                      staticClass:
                        "center heading-text-20 line-height-24 color-ffffff pt-12 pb-12 pl-50 pr-50 mb-0"
                    },
                    [_vm._v("#cc9636")]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "colo-platte-inner colpie-17 bg-color-23727b border-radius-5 float-l"
                },
                [
                  _c(
                    "p",
                    {
                      staticClass:
                        "center heading-text-20 line-height-24 color-ffffff pt-12 pb-12 pl-50 pr-50 mb-0"
                    },
                    [_vm._v("#23727b")]
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "color-platte-main width-full mt-8" }, [
              _c(
                "div",
                {
                  staticClass:
                    "colo-platte-inner colpie-17 bg-color-2d4419 border-radius-5 mr-50 float-l"
                },
                [
                  _c(
                    "p",
                    {
                      staticClass:
                        "center heading-text-20 line-height-24 color-ffffff pt-12 pb-12 pl-50 pr-50 mb-0"
                    },
                    [_vm._v("#2d4419")]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "colo-platte-inner colpie-17 bg-color-997029 border-radius-5 mr-50 float-l"
                },
                [
                  _c(
                    "p",
                    {
                      staticClass:
                        "center heading-text-20 line-height-24 color-ffffff pt-12 pb-12 pl-50 pr-50 mb-0"
                    },
                    [_vm._v("#997029")]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "colo-platte-inner colpie-17 bg-color-195158 border-radius-5 float-l"
                },
                [
                  _c(
                    "p",
                    {
                      staticClass:
                        "center heading-text-20 line-height-24 color-ffffff pt-12 pb-12 pl-50 pr-50 mb-0"
                    },
                    [_vm._v("#195158")]
                  )
                ]
              )
            ])
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-aced122a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-aced122a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/colorchart.vue
// module id = null
// module chunks = 